import { render, staticRenderFns } from "./TermsAndPolicy.vue?vue&type=template&id=2ea292e6"
import script from "./TermsAndPolicy.vue?vue&type=script&lang=js"
export * from "./TermsAndPolicy.vue?vue&type=script&lang=js"
import style0 from "./TermsAndPolicy.vue?vue&type=style&index=0&id=2ea292e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports